module.exports = __webpack_public_path__ + "img/login-chullagol.e89d15bc.svg";